window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
Interface();

import Address from 'components/address.js';
import { togglePassword } from 'components/utils.js';

window.addEventListener("DOMContentLoaded", (event) =>
{
    const place = new Address.Place();
    place.init();
    togglePassword();

    if (document.getElementById('cw-country'))
    {
    document.getElementById('cw-country').addEventListener('change', (event) =>
    {
        Address.getStates({id:event.target.value, object:document.getElementById('account-states')});
    });
    }
});